module.exports = __webpack_public_path__ + "media/images/frontend/cust_grid_view-d7d713044a3c64dfae6179736445d45a.svg";